<template>
  <popup class="success-dialog success-dialog--sms" :showModalClose="true" :isWhite="true">
    <div slot="header">
      <h3>{{$tr('invites.smsModal.title')}}</h3>
    </div>

    <div slot="body">
      <div class="body" v-html="$tr('invites.smsModal.body', {
        sms_need: smsNeed,
        sms_balance: smsBalance,
        sms_count: invitesCount
      })"></div>
    </div>

    <div slot="footer">
      <div class="buttons-wrapper">
        <button class="vcv-button" :loading="loading" :disabled="loading" @click="$emit('submit')">{{$tr('invites.smsModal.submit')}}</button>
        <button class="vcv-button" :loading="loading" :disabled="loading" @click="$emit('request')">{{$tr('invites.smsModal.request')}}</button>
        <button class="vcv-button gray" :loading="loading" :disabled="loading" @click="$emit('close')">{{$tr('common.cancel')}}</button>
      </div>
    </div>
  </popup>
</template>

<script>
import Popup from '@/components/modals/Popup.vue';

export default {
  name: 'SmsModal',
  components: {
    Popup
  },
  props: ['loading', 'model'],
  data() {
    return {
      
    }
  },
  computed: {
    invitesCount() {
      if (!this.model || !this.model.invitesCount) {
        return 0;
      }

      return this.model.invitesCount;
    },
    smsBalance() {
      if (!this.model || !this.model.limits) {
        return 0;
      }

      return this.model.limits.sms_balance;
    },
    smsNeed() {
      return this.invitesCount - this.smsBalance;
    },
  },
}
</script>

<style lang="scss" scoped>
  .success-dialog--sms {
    ::v-deep {
      .close-icon {
        position: absolute;
        right: 10px;
        top: 10px;
      }

      .buttons-wrapper {
        display: flex;
      }

      .modal-container {
        width: 710px;
      }
    }
  }
</style>